import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const TopPostsCarousel = ({ posts, onPostClick }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const nextPost = () => {
    setCurrentIndex((prev) => (prev + 1) % posts?.length);
  };

  const prevPost = () => {
    setCurrentIndex((prev) => (prev - 1 + posts?.length) % posts?.length);
  };

  const currentPost = posts?.[currentIndex];

  return (
    <div className="bg-card rounded-lg border border-border p-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-foreground">Top Performing Posts</h3>
        <div className="flex items-center gap-2">
          <button
            onClick={prevPost}
            className="p-2 rounded-lg hover:bg-muted transition-colors"
            aria-label="Previous post"
          >
            <Icon name="ChevronLeft" size={20} />
          </button>
          <span className="text-sm text-muted-foreground">
            {currentIndex + 1} / {posts?.length}
          </span>
          <button
            onClick={nextPost}
            className="p-2 rounded-lg hover:bg-muted transition-colors"
            aria-label="Next post"
          >
            <Icon name="ChevronRight" size={20} />
          </button>
        </div>
      </div>
      <div className="space-y-4">
        <div className="relative w-full h-48 rounded-lg overflow-hidden bg-muted">
          <Image
            src={currentPost?.image}
            alt={currentPost?.imageAlt}
            className="w-full h-full object-cover"
          />
          <div className="absolute top-2 right-2 bg-black/70 text-white px-2 py-1 rounded text-xs font-medium">
            {currentPost?.type}
          </div>
        </div>

        <div className="space-y-3">
          <p className="text-sm text-foreground line-clamp-3">{currentPost?.content}</p>
          
          <div className="flex items-center gap-4 text-sm">
            <div className="flex items-center gap-1 text-muted-foreground">
              <Icon name="Eye" size={16} />
              <span>{currentPost?.reach?.toLocaleString()}</span>
            </div>
            <div className="flex items-center gap-1 text-muted-foreground">
              <Icon name="Heart" size={16} />
              <span>{currentPost?.reactions?.toLocaleString()}</span>
            </div>
            <div className="flex items-center gap-1 text-muted-foreground">
              <Icon name="MessageCircle" size={16} />
              <span>{currentPost?.comments?.toLocaleString()}</span>
            </div>
            <div className="flex items-center gap-1 text-muted-foreground">
              <Icon name="Share2" size={16} />
              <span>{currentPost?.shares?.toLocaleString()}</span>
            </div>
          </div>

          <div className="flex items-center justify-between pt-3 border-t border-border">
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 rounded-full bg-primary/20 flex items-center justify-center">
                <Icon name="TrendingUp" size={16} className="text-primary" />
              </div>
              <div>
                <p className="text-xs text-muted-foreground">Engagement Rate</p>
                <p className="text-sm font-semibold text-foreground">{currentPost?.engagementRate}%</p>
              </div>
            </div>
            <Button
              variant="outline"
              size="sm"
              iconName="ExternalLink"
              onClick={() => onPostClick(currentPost)}
            >
              View Details
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopPostsCarousel;